<template>
  <q-toggle v-model="darkMode" @update:model-value="toggleDarkMode" size="lg"  unchecked-icon="dark_mode" checked-icon="light_mode" :false-value="true" :true-value="false" :disable="disableUserFunctionality"
    :title="`Turn ${darkMode ? 'Off' : 'On'} Dark Mode`" :aria-label="`Turn ${darkMode ? 'Off' : 'On'} Dark Mode`"/>
  <q-btn flat no-caps label="Help" style="font-size: 20px;" @click="helpButtonClick" :disabled="disableUserFunctionality" v-if="helpScreen !== 'logsPage'" />

  <q-dialog v-model="systemAnnouncementDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="border-radius: 10px;" class="q-pa-md">
          <q-card-section>
            <q-card-actions align="right" class="text-primary">
              <q-btn icon="close" flat round dense v-close-popup align="right" class="circle-btn" style="margin-bottom: 5px" />
            </q-card-actions>

            <h4 class="helpHeader">Announcements</h4>

            <h6 style="text-align: center; font-weight: 600; margin-bottom: 20px; margin-top: 30px">
              {{systemAnnouncement}}
            </h6>

            <q-card-actions align="center" class="text-primary">
              <q-btn unelevated no-caps text-color="white" class="helpDialogButton" label="Dismiss" v-close-popup />
            </q-card-actions>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-dialog>

  <AdminHelpTour
    ref="adminHelpTour"
  />

  <HelpTour
    :userAdminAccessLevel="userAdminAccessLevel"
    :userEditAccessLevel="userEditAccessLevel"
    :userUploadAccessLevel="userUploadAccessLevel"
    :feedbackForm="feedbackForm"
    :changePassword="changePassword"
    ref="helpTour"
  />

</template>

<script>
import { onMounted, nextTick, ref } from 'vue'
import { useQuasar } from 'quasar'
import AdminHelpTour from "./AdminHelpTour.vue";
import HelpTour from "./HelpTour.vue";

export default ({
  props: {
    disableUserFunctionality: Boolean,
    userAdminAccessLevel: Boolean,
    userEditAccessLevel: Boolean,
    userUploadAccessLevel: Boolean,
    feedbackForm: Object,
    changePassword: Object,
    helpScreen: String,
  },
  emits: ["toggleDarkMode"],
  components: {
    AdminHelpTour,
    HelpTour,
  },
  setup (props, {emit}) {
    const systemAnnouncement = process.env.VUE_APP_SYSTEM_ANNOUNCEMENT;
    const systemAnnouncementDialog = ref(systemAnnouncement != null && systemAnnouncement != "");
    const adminHelpTour = ref();
    const helpTour = ref();
    const darkMode = ref(false);
    const $q = useQuasar();

    onMounted(() => {
      nextTick(() => {
        // the combination of onMounted and nextTick sets the following code to be run after the page has fully loaded
        darkMode.value = $q.dark.isActive;
        toggleDarkMode();
      })
    });

    function toggleDarkMode() {
      emit("toggleDarkMode", darkMode.value);

      if (darkMode.value) {
        // Dark Mode On
        switch (props.helpScreen) {
          case "searchEngineContent":
            document.documentElement.style.setProperty("--spinner-clr-bg", "#4A4A4A");
            document.documentElement.style.setProperty("--spinner-clr-bg-table", "#272324");
            document.documentElement.style.setProperty("--spinner-clr-outer", "#FFFFFF");
            document.documentElement.style.setProperty("--results-tableheaderbackground", "rgba(29,29,29)");
            document.documentElement.style.setProperty("--results-tableheadercolor", "white");
            document.documentElement.style.setProperty("--results-pageinate-color", "white");
            document.getElementsByClassName("ag-theme-material")[0].classList.add("darkModeTable");
            document.getElementsByClassName("ag-paging-page-summary-panel")[0].classList.add("darkModeTable");
            document.getElementsByClassName("ag-paging-row-summary-panel")[0].classList.add("darkModeTable");
            document.documentElement.style.setProperty("--action-button-color", "#B3D9FF");
            break;
          case "adminPage":
            document.getElementsByClassName("form-container")[0].style.setProperty("background", "#1D1D1D");
            break;
        }
      } else {
        // Dark Mode Off
        switch (props.helpScreen) {
          case "searchEngineContent":
            document.documentElement.style.setProperty("--spinner-clr-bg", "#FFFFFF");
            document.documentElement.style.setProperty("--spinner-clr-bg-table", "#FFFFFF");
            document.documentElement.style.setProperty("--spinner-clr-outer", "#272324");
            document.documentElement.style.setProperty("--results-tableheaderbackground", "white");
            document.documentElement.style.setProperty("--results-tableheadercolor", "black");
            document.documentElement.style.setProperty("--results-pageinate-color", "rgba(0, 0, 0, 0.54)");
            document.getElementsByClassName("ag-theme-material")[0].classList.remove("darkModeTable");
            document.getElementsByClassName("ag-paging-page-summary-panel")[0].classList.remove("darkModeTable");
            document.getElementsByClassName("ag-paging-row-summary-panel")[0].classList.remove("darkModeTable");
            document.documentElement.style.setProperty("--action-button-color", "#0067C1");
            break;
          case "adminPage":
            document.getElementsByClassName("form-container")[0].style.setProperty("background", "white");
            break;
        }
      }

      $q.dark.set(darkMode.value);
    }

    function helpButtonClick() {
      switch (props.helpScreen) {
        case "searchEngineContent":
          helpTour.value.displayHelpTourDialog();
          break;
        case "adminPage":
          adminHelpTour.value.displayAdminHelpTourDialog();
          break;
      }
    }

    return {
      systemAnnouncement,
      systemAnnouncementDialog,
      adminHelpTour,
      helpTour,
      darkMode,

      //functions
      toggleDarkMode,
      helpButtonClick,
    }
  }
})
</script>
